<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitle1"><a id="page_xiii"><b><span class="small">NOTE ON TRANSLITERATION AND TRANSLATION</span></b></a></p><a id="page_xiii">
<p class="noindentb"><span class="span1">T</span><span class="small">RANSLITERATING THE</span> B<span class="small">ULGARIAN</span> C<span class="small">YRILLIC ALPHABET</span> into Latin letters can be challenging because there are multiple accepted traditions including the US Library of Congress transliteration system. Throughout the book, I have followed the official Bulgarian government version published in 2013. Hence, I have transliterated Cyrillic letters as follows:</p>
<table cellpadding="0" cellspacing="0" class="table1" width="50%">
<colgroup><col width="8%"/>
<col width="8%"/>
<col width="34%"/>
</colgroup><tbody><tr>
<td valign="top"><p class="tab1">B</p></td>
<td valign="top"><p class="tab1">→</p></td>
<td valign="top"><p class="tab1">v</p></td>
</tr>
<tr>
<td valign="top"><p class="tab1">З</p></td>
<td valign="top"><p class="tab1">→</p></td>
<td valign="top"><p class="tab1">z</p></td>
</tr>
<tr>
<td valign="top"><p class="tab1">Ж</p></td>
<td valign="top"><p class="tab1">→</p></td>
<td valign="top"><p class="tab1">zh</p></td>
</tr>
<tr>
<td valign="top"><p class="tab1">Ч</p></td>
<td valign="top"><p class="tab1">→</p></td>
<td valign="top"><p class="tab1">ch</p></td>
</tr>
<tr>
<td valign="top"><p class="tab1">Ш</p></td>
<td valign="top"><p class="tab1">→</p></td>
<td valign="top"><p class="tab1">sh</p></td>
</tr>
<tr>
<td valign="top"><p class="tab1">Щ</p></td>
<td valign="top"><p class="tab1">→</p></td>
<td valign="top"><p class="tab1">sht</p></td>
</tr>
<tr>
<td valign="top"><p class="tab1">Ц</p></td>
<td valign="top"><p class="tab1">→</p></td>
<td valign="top"><p class="tab1">ts</p></td>
</tr>
<tr>
<td valign="top"><p class="tab1">X</p></td>
<td valign="top"><p class="tab1">→</p></td>
<td valign="top"><p class="tab1">h</p></td>
</tr>
<tr>
<td valign="top"><p class="tab1">Й</p></td>
<td valign="top"><p class="tab1">→</p></td>
<td valign="top"><p class="tab1">y</p></td>
</tr>
<tr>
<td valign="top"><p class="tab1">Ю</p></td>
<td valign="top"><p class="tab1">→</p></td>
<td valign="top"><p class="tab1">yu</p></td>
</tr>
<tr>
<td valign="top"><p class="tab1">Я</p></td>
<td valign="top"><p class="tab1">→</p></td>
<td valign="top"><p class="tab1">ya</p></td>
</tr>
<tr>
<td valign="top"><p class="tab1">у</p></td>
<td valign="top"><p class="tab1">→</p></td>
<td valign="top"><p class="tab1">u</p></td>
</tr>
<tr>
<td valign="top"><p class="tab1">Ъ</p></td>
<td valign="top"><p class="tab1">→</p></td>
<td valign="top"><p class="tab1">a</p></td>
</tr>
</tbody></table>
<p class="indent">The only exception to this rule is for “Bulgaria” and names that have been conventionally spelled with “ia” instead of “ya.” All translation from Bulgarian to English throughout the book is mine.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 09_FM02.vue?43a62dd4